import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {AppComponent} from './app.component';
import {AuthentificationService} from './authentification.service';
import {TransactionsService} from './transactions.service';
import {DetailsForSupplierComponent} from './details-for-supplier.component';
import {FileDownloadService} from './file-download.service';

import {Router} from '@angular/router';

@Component({
    selector: 'return-from-client',
    templateUrl: './templates/return-from-supplier.component.html',
    styleUrls: ['./styles/return-from-supplier.component.css'],
    providers: [AuthentificationService, AppComponent, TransactionsService, DetailsForSupplierComponent, FileDownloadService]
})
export class ReturnFromSupplierComponent implements OnInit {

    bret_list: Array<any> = [];
    bret_details: Array<any> = [];
    bret: any;
    number: any;
    date: any;

    ref_search: any = "";
    bcf_search: any = "";

    constructor(private app_component: AppComponent,
        private authentification_service: AuthentificationService,
        private router: Router,
        private transactions_service: TransactionsService,
        private filedownloadservice: FileDownloadService
    ) {

        this.CheckUSerSession();
        this.app_component.valTest = '/return-from-suppliers';
        this.app_component.GetParent();
    }

    CheckUSerSession(): void {
        this.authentification_service.UserCheckSession().then(result => {if (result['id_user'] === 0) {this.router.navigate(['authentification'])} });
    }

    Search(): void {
        //console.log(this.ref_search, this.bcf_search);
        this.transactions_service.SearchreturnFromSupplier('BRF_' + this.ref_search, 'BCF_' + this.bcf_search).then(result => {this.bret_list = result['list'];});
    }

    GetRetournFromSuppliers() {
        this.transactions_service.GetRetournFromSuppliers().then(result => {this.bret_list = result['list'];});
    }

    ShowDetails(bret: any): void {
        //console.log(bret);
        // this.details_for_supplier.ShowInfos(bret);  
        this.bret = bret;
        // let id_purchase_order = bret.id_purchase_order;
        let id_purchase_order = bret.antecedent;
        this.transactions_service.GetPurchaseOrdersDetails(id_purchase_order).then(result => {this.number = result['infos'][0]['reference']; this.date = result['infos'][0]['creation_date']; this.bret_details = result['list']; console.log(result['infos'][0]['reference'])});
    }


    DownloadPdf(): void {
        this.filedownloadservice.PurchaseOrder(this.bret);
    }

    ngOnInit() {
        this.Search();
        //this.GetRetournFromSuppliers();
    }


}



// WEBPACK FOOTER //
// ./src/app/return-from-supplier.component.ts